module.exports = __webpack_public_path__ + "static/images/serviceQrCode.0368e56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/serviceQrCode.png
// module id = 6Ggr
// module chunks = 0